/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'point',
    path: '/point',
    meta: { tabbar: 'secret/user', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'point_index' },
    children: [
      {
        name: 'point_index',
        path: '',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '我的积分' },
        component: () => import('@/views/user/point/index.vue'),
      },
      {
        name: 'point_earn',
        path: 'earn',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '获取更多积分' },
        component: () => import('@/views/user/point/earn.vue'),
      },
      {
        name: 'point_codes',
        path: 'codes',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '兑换码' },
        component: () => import('@/views/user/point/codes.vue'),
      },
      {
        name: 'point_exchange',
        path: 'exchange/:feature',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '兑换' },
        component: () => import('@/views/user/point/exchange.vue'),
      },
      {
        name: 'point_logs',
        path: 'logs',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '积分明细' },
        component: () => import('@/views/user/point/logs.vue'),
      },
    ],
  },
] as RouteConfig[];
